import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getSubscriptionFlowApiClient } from "@shared/apis/sidekick/api-factories";
import { MembershipAffiliationDto } from "@shared/apis/sidekick/generated";
import {
  ApiError,
  apiResponseErrorHandler,
} from "@shared/apis/sidekick/api-error-handler";

const GET_MEMBERSHIP_AFFILIATIONS_QUERY_KEY = "membership-affiliations";

type Props = {
  onSuccess?: (data: MembershipAffiliationDto[]) => void;
  onError?: (error: ApiError) => void;
};

export const useGetMembershipAffiliations = (props?: Props) => {
  const api = getSubscriptionFlowApiClient();
  const query = useQuery({
    queryKey: [GET_MEMBERSHIP_AFFILIATIONS_QUERY_KEY],
    queryFn: async () => {
      try {
        const { items } =
          await api.subscriptionFlowControllerGetMembershipAffiliations();
        props?.onSuccess?.(items);
        return items;
      } catch (e) {
        console.error("Error trying to fetch membership affiliations", e);
        const error = await apiResponseErrorHandler(e);
        props?.onError?.(error);
        throw error;
      }
    },
    refetchOnWindowFocus: false,
    retry: 3,
  });

  return extractQueryState(query);
};
